import { FleekError } from './FleekError';

type QueuedDeploymentsLimitErrorOptions = {
  limit: number;
};

export class QueuedDeploymentsLimitError extends FleekError<QueuedDeploymentsLimitErrorOptions> {
  public name = 'QueuedDeploymentsLimitError';

  toString = () => `You've reached the limit of ${this.data.limit} queued deployments.`;
}
